"use client";

import Image from "next/image";
import { z } from "zod";

import { Section } from "@/common/components-2/section";
import { CmsSectionHeading } from "@/common/components-2/section-heading/cms-section-heading";
import type { HranoPage } from "@/payload-types";
import { imageSchema } from "@/services/cms/cms.schema";
import { EmitErrorReport } from "@/services/cms/components/emit-error-report";

import { AgendaItem } from "../../components";

const agendaSectionSchema = z.object({
  heading: z.string(),
  image: imageSchema,
  items: z.array(
    z.object({
      icon: z.string(),
      title: z.string(),
      description: z.string(),
    }),
  ),
});

export function AgendaSection(props: HranoPage["as"]) {
  let propsData: z.infer<typeof agendaSectionSchema>;

  try {
    propsData = agendaSectionSchema.parse(props);
  } catch (ex) {
    return <EmitErrorReport error={JSON.stringify(ex)} name="Agenda section" />;
  }

  const { heading, image, items } = propsData;

  return (
    <Section classes={{ section: "scroll-mt-12 bg-white-linen-50 py-12 md:py-14 lg:py-20" }} id="agenda">
      <CmsSectionHeading heading={heading} />
      <div className="mt-4 flex flex-col gap-12 md:flex-row">
        <div className="w-full md:w-1/2">
          <Image src={image.url} alt={image.alt} width={image.width} height={image.height} />
        </div>
        <div className="flex flex-col gap-4 md:w-1/2">
          {items.map((item) => (
            <AgendaItem key={item.title} {...item} />
          ))}
        </div>
      </div>
    </Section>
  );
}
